module.exports = __webpack_public_path__ + "static/blue_dragon_wyrmling-2-bf18835266760564b892f6b6403a18f0.jpg";